import { ArrowLeft } from "lucide-react";

interface BreadcrumbProps {
  pageTitle: string;
  pageDescription?: string;
  onBack?: () => void;
  showBackButton?: boolean;
}

const PageBreadcrumb: React.FC<BreadcrumbProps> = ({
  pageTitle,
  pageDescription,
  onBack,
  showBackButton = false
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
      <div className="flex items-center gap-2">
        {showBackButton && onBack && (
          <button
            onClick={onBack}
            className="inline-flex items-center justify-center p-1 text-gray-700 hover:text-brand-500 dark:text-gray-300 dark:hover:text-brand-400 transition-colors"
            aria-label="Voltar"
          >
            <ArrowLeft size={20} />
          </button>
        )}
        <div>
          <h2
            className="text-xl font-semibold text-gray-800 dark:text-white/90"
            x-text="pageName"
          >
            {pageTitle}
          </h2>
          {pageDescription && (
            <span className="mt-1 block text-gray-500 text-theme-xs dark:text-gray-400">
              {pageDescription}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageBreadcrumb;
